__turbopack_context__.v({
  "App__mainContainer": "page-module___8aEwW__App__mainContainer",
});
